import React from "react";
import { CheckLabel } from "@sscs/ui";
import { LevelInfoLabel } from "../../../ui";
import { useLevels } from "../../hooks";
import styles from "./statusLabel.module.scss";
const StatusLabel = ({ status, enabled, level, }) => {
    const { scanLevel, isLevelCustomized } = useLevels();
    return (React.createElement("div", { className: styles.root },
        React.createElement(CheckLabel, { scanLevel: scanLevel, status: status, isLevelCustomized: isLevelCustomized }),
        React.createElement(LevelInfoLabel, { policyLevel: level, status: status, enabled: enabled, scanLevel: scanLevel })));
};
export default StatusLabel;
//# sourceMappingURL=StatusLabel.js.map